import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68ed6c18&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed6c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ed6c18')) {
      api.createRecord('68ed6c18', component.options)
    } else {
      api.reload('68ed6c18', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68ed6c18&scoped=true&", function () {
      api.rerender('68ed6c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/AviationExchangePriceWarning/index.vue"
export default component.exports